import "./ExpandedServices.css";
import { Link, useLocation } from "react-router-dom";

import cataloguesIcon from "../../../Assets/Icons/cataloges-icon.svg";
import customDevelopmentIcon from "../../../Assets/Icons/custom-dev-icon.svg";
import devForHireIcon from "../../../Assets/Icons/dev-for-hire-icon.svg";
import webDevIcon from "../../../Assets/Icons/web-dev-icon.svg";
import mobileDevIcon from "../../../Assets/Icons/mobile-dev-icon.svg";
import softwareConsultingIcon from "../../../Assets/Icons/software-consulting-icon.svg";
import dataAnalyticsIcon from "../../../Assets/Icons/data-analytics-icon.svg";

const ExpandedServices = () => {
  const services = [
    {
      name: "Custom Software Development",
      icon: customDevelopmentIcon,
      description:
        "Our Custom Software Development service provides tailored, end-to-end solutions designed around your unique needs.",
      path: "/services/custom-software-development",
    },
    {
      name: "Developers for Hire",
      icon: devForHireIcon,
      description:
        "Offering top-tier software developers in the UK and abroad with our “Developers for Hire” service.",
      path: "/services/developers-for-hire",
    },
    {
      name: "Web Development",
      icon: webDevIcon,
      description:
        "Our web development services include custom website design, e-commerce solutions, and mobile-responsive designs",
      path: "/services/web-development",
    },
    {
      name: "Mobile App Development",
      icon: mobileDevIcon,
      description:
        "Bring your app ideas to life with our Mobile App Development services.",
      path: "/services/mobile-app-development",
    },
    {
      name: "Software Consulting",
      icon: softwareConsultingIcon,
      description:
        "Empower your business with our expert Software Consulting services.",
      path: "/services/software-consulting",
    },
    {
      name: "Data Analytics",
      icon: dataAnalyticsIcon,
      description:
        "Unlock actionable insights and drive growth with our dynamic Data Analytics services.",
      path: "/services/data-analytics",
    },
  ];

  const blueBackgroundRoutes = [
    "/services/software-consulting",
    "/career",
    "/contact-us",
    "/contact-us/hiring-team",
    "/contact-us/build-business",
    "/blog1",
    "/blog2",
    "/blog3",
    "/technologies",
    "/technologies/web",
    "/technologies/mobile",
    "/technologies/ui-ux",
    "/technologies/cloud",
    "/technologies/database",
  ];

  const location = useLocation();
  const isBlueBackground = blueBackgroundRoutes.includes(location.pathname);

  return (
    <div
      className={`expanded-services-container ${
        isBlueBackground ? "expanded-services-container--high-opacity" : ""
      }`}
    >
      <div className="expanded-services-content">
        {/* Left Column */}
        <div className="services-left">
          <div className="services-title">
            <img
              src={cataloguesIcon}
              alt="Services"
              className="services-icon"
            />
            <h3>Our Services</h3>
          </div>
          <p>
            We provide end-to-end software development services that drive
            innovation and efficiency.
          </p>
        </div>

        {/* Right Column - Grid of Service Cards */}
        <div className="services-right">
          <div className="services-grid">
            {services.map((service, idx) => (
              <Link
                key={idx}
                to={service.path}
                className="services-item" // Apply same class as before for styling
              >
                <img
                  src={service.icon}
                  alt={service.name}
                  className="services-item-icon"
                />
                <div className="services-item-content">
                  <h4>{service.name}</h4>
                  <p>{service.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandedServices;
